import { defineComponent as _defineComponent } from 'vue'
import AnalyticsAside from './AnalyticsAside.vue'
import AnalyticsEmptyPage from './AnalyticsEmptyPage.vue'
import AnalyticsDisabledPage from './AnalyticsDisabledPage.vue'
import CustomTransition from '@/components/common/Transition.vue'
import { useGetDashboardsQuery } from '@/api/dashboards'
import { useStore } from 'vuex-composition-helpers'
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'Analytics',
  setup(__props) {

document.title = 'Analytics - IronSight'

const route = useRoute()
const router = useRouter()
const store = useStore()
const analyticsDrillDownsEnabled = computed<boolean>(
  () => store.getters['featureFlags/analyticsDrillDownEnabled']
)
const canViewAnalyticsDrillDowns = computed<boolean>(
  () => store.getters['permissions/canViewAnalyticsDrillDowns']
)
const dashBoardsDisabled = computed(
  () => analyticsDrillDownsEnabled.value && !canViewAnalyticsDrillDowns.value
)
const { data: dashboards, isFetching, isFetched } = useGetDashboardsQuery()

const pushToTheFirstDashboard = () => {
  if (dashboards.value === undefined || dashboards.value.length === 0) return
  router.push({
    name: 'new-metabase-dashboard',
    params: {
      id: dashboards.value[0].id.toString(),
    },
  })
}

watch(
  isFetched,
  (newValue) => {
    if (newValue && route.name === 'analytics') {
      pushToTheFirstDashboard()
    }
  },
  { immediate: true }
)

watch(
  () => route.name,
  (newValue) => {
    if (newValue === 'analytics') {
      pushToTheFirstDashboard()
    }
  }
)

return { __sfc: true,route, router, store, analyticsDrillDownsEnabled, canViewAnalyticsDrillDowns, dashBoardsDisabled, dashboards, isFetching, isFetched, pushToTheFirstDashboard, AnalyticsAside, AnalyticsEmptyPage, AnalyticsDisabledPage, CustomTransition }
}

})